import * as React from "react"

interface ExpenseFormContextType {
  isOpen: boolean
  openAddExpenseForm: () => void
  closeExpenseForm: () => void
}

const ExpenseFormContext = React.createContext<ExpenseFormContextType | undefined>(undefined)

export const ExpenseFormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const openAddExpenseForm = () => setIsOpen(true)
  const closeExpenseForm = () => setIsOpen(false)

  return (
    <ExpenseFormContext.Provider value={{ isOpen, openAddExpenseForm, closeExpenseForm }}>
      {children}
    </ExpenseFormContext.Provider>
  )
}

export const useExpenseForm = () => {
  const context = React.useContext(ExpenseFormContext)
  if (!context) {
    throw new Error("useExpenseForm must be used within ExpenseFormProvider")
  }
  return context
}